export * from './phone-verify.component';
